import { getSuggestedAnswerItemPayload } from '../../shared/logic/get-suggested-answer-item-payload';
import type { SuggestedAnswerFragment } from '../../suggested-answers/suggested-answers.graphql.generated';
import { FillInBlanksSentence } from '../fill-in-blanks.constants';

export function getDeleteSentencePayload({
  activeSentenceId,
  sentences,
  suggestedAnswerProperties,
}: {
  activeSentenceId: string;
  sentences: FillInBlanksSentence[];
  suggestedAnswerProperties: SuggestedAnswerFragment | null;
}) {
  const sentenceToDelete = sentences.find(s => s.itemId === activeSentenceId);
  const answerBlockItemIdsInSentence =
    sentenceToDelete?.answerBlocks.map(an => an.itemId) || [];

  const suggestedAnswers =
    suggestedAnswerProperties?.suggestedAnswers?.filter(
      suggestedAnswer =>
        !answerBlockItemIdsInSentence.includes(
          suggestedAnswer.answerReferences?.id || ''
        )
    ) || [];

  return {
    sentences: sentences.filter(s => s.itemId !== activeSentenceId),
    suggestedAnswers: suggestedAnswers.map(a =>
      getSuggestedAnswerItemPayload(a)
    ),
  };
}
